import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { FuncionService } from '../../servicios/funcion.service';
import { environment } from '../../../environments/environment.prod';

@Component({
	selector: 'app-activacion',
	templateUrl: './activacion.component.html',
	styleUrls: ['./activacion.component.css']
})
export class ActivacionComponent implements OnInit {

	constructor( 
		private newFuncionService:FuncionService, 
		private newActivatedRoute:ActivatedRoute, 
		private newRouter:Router,
		private newTitle: Title,
	) {}

	ngOnInit(): void {
		this.newTitle.setTitle("Activación");
		this.newActivatedRoute.paramMap.subscribe( (newRouterParams:any) => {
			this.newFuncionService.fnActivarCuenta( {code:newRouterParams.params.cuenta} )
			.subscribe( (response:any) =>{
				if( response.success ){
					this.newFuncionService.setNewAlerta( environment.alerta.activacion.success );
					this.newRouter.navigate([ 'acceso' ]);
					this.newFuncionService.fnSetUuid( response.uuid );
				}else{
					if( response.code == 0 ){
						this.newFuncionService.setNewAlerta( environment.alerta.activacion.notExist );
					}else if( response.code == 1 ){
						this.newFuncionService.setNewAlerta( environment.alerta.activacion.notFound );
					}
					this.newRouter.navigate([ 'registro' ]);
				}
			});
		})
	}

}
